import { SubscriptionsStore } from "@ts/common/service/Store/SubscriptionsStore";
export var SubscriptionsStoreInstance = new SubscriptionsStore();
